import {Box, Typography} from "@mui/material";
import {c, maxW, section, eyebrowSx, h2Sx} from "../landingTokens";

/** Centered max-width column used by every section. */
export const Wrap = ({children, sx}) => (
  <Box sx={{maxWidth: maxW, mx: "auto", ...sx}}>{children}</Box>
);

/** <Section id="specs"> — handles the page's vertical rhythm and side padding. */
export const Section = ({id, label, children, sx}) => (
  <Box
    component="section"
    id={id}
    data-screen-label={label}
    sx={{px: section.px, pb: section.pb, scrollMarginTop: {xs: 78, md: 88}, ...sx}}
  >
    <Wrap>{children}</Wrap>
  </Box>
);

export const Eyebrow = ({children, sx}) => (
  <Typography sx={{...eyebrowSx, ...sx}}>{children}</Typography>
);

export const SectionHeading = ({children, sx}) => (
  <Typography component="h2" sx={{...h2Sx, ...sx}}>
    {children}
  </Typography>
);

/** Muted second line of a two-tone heading. */
export const Dim = ({children}) => (
  <Box component="span" sx={{color: c.inkMuted}}>{children}</Box>
);
